export default "__VITE_ASSET__5DKiLigo__"